import { Component, DestroyRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CarouselService } from "../../Services/carousel.service";
import { ProductConfigurationService } from "../../Services/product-configuration.service";
import { Response } from "../../Models/response";
import { Page } from "../../Models/page";
import { ProductConfiguration } from "../../Models/product-configuration";
import { DisplayService } from "../../Services/display.service";
import { DisplayHomeSections } from "../../Models/display-home-sections";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../Services/order.service";
import {
  Slide as LibSlide,
  Slide,
} from "admin-common";
import { ProductService } from "src/app/Services/product.service";
import { Product } from "src/app/Models/product";
import { Category } from "../../Models/category";
import { CategoryService } from "../../Services/category.service";
import { AccueilSetyCoreComponent, TopCategory } from "admin-common";
import { BrandService } from "src/app/Services/brand.service";
import { Brand } from "src/app/Models/brand";
import { takeUntil, take, Subject, forkJoin, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AccountService } from "src/app/Services/account.service";
import { CartService } from "src/app/Services/cart.service";
import { CartOffLineService } from "src/app/Services/cartOffline.service";
import { FavoriteService } from "src/app/Services/favorite.service";
import { CartProduct } from "src/app/Models/cart-product";
import { cartLocal } from "../products/detail-page/detail-page.component";
import { StorageService } from "../../Services/storage.service";
import { TranslateService } from "@ngx-translate/core";

// admin-common does not export ProductModel; use the type of the input these products are bound to.
type ProductModel = AccueilSetyCoreComponent["productsList"][number];

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  theme: any = "WUnivers";
  autoPlay!: boolean;
  slides: LibSlide[] = [];
  product?: Product | null;
  autoPlayInterval!: number;
  showArrows!: boolean;
  showDots!: boolean;
  readonly DEFAULT_PRODUCT_IMAGE = "assets/images/logo_placeholder.png";

  // Carousel bottom links
  contactUsLink: string = "/contact";
  discoverProductsLink: string = "/products";

  /** "Les tops catégories" cards shown under the avantages row (see buildTopCategories). */
  topCategories: TopCategory[] = [];

  // Product slider inputs
  title: string = "homePage.home.newArrivalTitle";
  /** Product slider subtitle (shop name shown above the title) */
  subtitle: string = "Wissal Univers";
  productsList: ProductModel[] = [];
  /** Configuration ids of the visitor's favorites */
  private favoriteConfigurationIds: number[] = [];
  private wishlistCache: { list: any[] | null; ids: number[] | null; result: number[] } = { list: null, ids: null, result: [] };
  private destroyRef = inject(DestroyRef);

  /** Shows the page once the carousel and the new arrivals are both loaded (same as setycore). */
  pageLoaded = false;

  /**
   * Carousel and new arrivals of the last visit, kept for the whole session: coming back to the home page shows them
   * right away instead of the full-page loader (which looked like a page refresh), while fresh data loads behind.
   */
  private static cachedHomeData: { slides: LibSlide[]; productsList: ProductModel[] } | null = null;

  brands: Brand[] = [];

  //imagesCarousel: Slide[] = [];
  showBestPromotion = false;
  showFlashSale = false;

  showFixedHeader = false;
  showHomeFixedHeaderMenu = false;
  configurations: ProductConfiguration[] = [];
  flashSaleConfigurations: ProductConfiguration[] = [];

  display: DisplayHomeSections[] = [];

  showNew = false;
  showBestSales = false;
  showTrading = false;
  showBestCategory = false;
  showBestPromotions = false;
  showFlashSales = false;
  showLastSeen = false;

  newName?: string;
  bestSalesName?: string;
  tradingName?: string;
  bestCategoryName?: string;
  bestPromotionName?: string;
  flashSalesName?: string;
  lastSeenName?: string;
  orderId?: number;
  bool?: number;
  gatewayOrderId?: string;
  MessageReturn?: string;
  // After changing the password from the profile page,
  // the user is automatically logged out and redirected to the Home page by the AuthGuard.
  // We must keep the success dialog visible on the Home page
  // and allow the user to log in again.
  showPasswordChangedPopup: boolean = false;
  showLoginModal: boolean = false;

  /** Controls visibility of the "product added to cart" confirmation popup */
  showAddPopup: boolean = false;

  /** Quantity displayed in the "product added to cart" popup */
  popQuantity: number = 1;

  /** Product configuration currently shown in the "added to cart" popup */
  popupConfiguration: ProductConfiguration | null = null;

  /** Available stock displayed in the "added to cart" popup */
  popupAvailableQuantity?: number;

  /** Snackbar params */
  showSnackbar: boolean = false;
  snackbarTheme: "warning" | "alert" | "success" | "information" = "success";
  snackbarText: string = "";

  private destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private storage: StorageService,
    private router: Router,
    private categoryService: CategoryService,
    private displayService: DisplayService,
    private productConfService: ProductConfigurationService,
    private carouselService: CarouselService,
    private productConfigurationService: ProductConfigurationService,
    private productService: ProductService,
    private brandService: BrandService,
    private accountService: AccountService,
    private cartService: CartService,
    private cartOffLineService: CartOffLineService,
    private favoriteService: FavoriteService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.favoriteService.favoriteConfigurationIds$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((ids: number[]) => (this.favoriteConfigurationIds = ids));
    this.showPasswordChangedPopup = Boolean(
      this.storage.getItem("passwordChanged"),
    );
    this.storage.removeItem("passwordChanged");
    this.theme = "WUnivers";
    this.autoPlay = true;
    this.autoPlayInterval = 3000;
    this.showArrows = true;
    this.showDots = true;
    this.loadHomeData();
    this.getActivatedCategories();
    //get brands list
    this.brandService.getAllPaged(0, 10).subscribe({
      next: (brandsList) => {
        this.brands = brandsList.content.filter(
          (brand: any) => brand.imageUrl !== "false",
        ) as Brand[];
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  getActivatedCategories() {
    this.categoryService.getAllActivated().subscribe({
      next: (categories: Category[]) => {
        this.categoryService.categoriesSubject.next(categories);
        this.topCategories = this.buildTopCategories(categories);
      },
      error: () => {
        //this.categoryService.categoriesSubject.next([]);
      },
    });
  }

  /**
   * Top-level categories for the home page's "tops catégories" row: the ones holding the most products first
   * (stable, so categories without a count keep the back-office order), each with its picture.
   */
  private buildTopCategories(categories: Category[]): TopCategory[] {
    return this.parentCategories(categories)
      .map((category, index) => ({ category, index }))
      .sort(
        (a, b) =>
          (b.category.numberOfProducts ?? 0) -
          (a.category.numberOfProducts ?? 0) || a.index - b.index,
      )
      .map(({ category }) => {
        const item: TopCategory = {
          id: category.id!,
          label: category.label,
          href: this.createHref(category.label, category.id!),
        };
        // The picture is only attached once it has loaded: until then (or when there is none / it is broken)
        // the tile shows the category's initial instead of a broken image. There is no Image on the server.
        if (category.image && isPlatformBrowser(this.platformId)) {
          const probe = new Image();
          probe.onload = () => {
            item.imageUrl = category.image;
          };
          probe.src = category.image;
        }
        return item;
      });
  }

  /** Same navigation as the header menu: hrefs look like `/#/products/category/...`. */
  onTopCategoryClick(category: TopCategory): void {
    const path = category.href.replace(/^\/?#/, "");
    this.router.navigateByUrl(path).then();
  }

  parentCategories(categories: Category[]): Category[] {
    return categories.filter(
      (category: Category) => category.parentId === null,
    );
  }

  subCategories(categories: Category[], id: number): Category[] {
    return categories.filter((category: Category) => category.parentId === id);
  }
  private createHref(
    categoryName: string,
    categoryId: number,
    subCategoryName?: string,
    subCategoryId?: number,
    subSubCatId?: number,
  ): string {
    const sanitizedCatName = categoryName.replace(/[^a-zA-Z0-9]/g, "-");

    const basePath = ["/#/products/category", categoryId, sanitizedCatName];

    if (subCategoryId && subCategoryName) {
      basePath.push(
        subCategoryId,
        subCategoryName.replace(/[^a-zA-Z0-9]/g, "-"),
      );
    }

    const queryParams = new URLSearchParams({
      categories: String(subSubCatId ?? ""),
      inStock: "true",
    }).toString();

    return basePath.join("/") + (queryParams ? `?${queryParams}` : "");
  }
  /**
   * Loads carousel slides and new-arrival products in parallel, then shows the page (same as setycore).
   * A failing call just leaves its section empty.
   */
  loadHomeData(): void {
    const cached = HomeComponent.cachedHomeData;
    if (cached) {
      this.slides = cached.slides;
      this.productsList = cached.productsList;
    }
    this.pageLoaded = !!cached;

    forkJoin({
      slides: this.carouselService
        .getCarouselSlides()
        .pipe(catchError(() => of([] as LibSlide[]))),
      products: this.productConfService.getNew().pipe(
        catchError((err) => {
          console.error("❌ Erreur lors du chargement des produits:", err);
          return of(null);
        }),
      ),
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ slides, products }: { slides: LibSlide[]; products: any }) => {
        // CAROUSEL
        this.slides = (slides || []).map((slide) => ({
          id: slide.id,
          imageUrl: slide.imageUrl,
          route: slide.route === "undefined" ? undefined : slide.route,
        }));

        // PRODUCTS
        if (Array.isArray(products?.content)) {
          this.productsList = products.content.map((product: any) => ({
            id: product.id,
            productId: product.productId,
            // The library's card reads `productId` for the raw product id (used for
            // navigation) and `selectedConfiguration.id` for the configuration id
            // (used for add-to-cart). Without it, add-to-cart falls back to the raw
            // product id instead of the configuration id.
            selectedConfiguration: { id: product.id },
            reference: product.reference,
            designation: product.name,
            description: this.stripHtml(product.description),
            quantity: product.quantity ?? 0,
            stockStatus: product.state,
            salePrice: product.price,
            images: [product.images?.[0]?.url || this.DEFAULT_PRODUCT_IMAGE],
          }));
          this.verifyProductImages(this.productsList);
        } else {
          this.productsList = [];
        }

        HomeComponent.cachedHomeData = {
          slides: this.slides,
          productsList: this.productsList,
        };
        this.pageLoaded = true;
      });
  }

  /**
   * The card component renders `description` via text interpolation (not
   * [innerHTML]), but the value is HTML authored via the admin WYSIWYG
   * editor. Strip the markup here so raw tags don't show up in the card.
   */
  private stripHtml(html?: string): string {
    if (!html) {
      return "";
    }
    return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  /**
   * Preloads each product's image and falls back to DEFAULT_PRODUCT_IMAGE
   * if it fails to load (e.g. expired/forbidden S3 link), since the API
   * returning a URL doesn't guarantee that URL is actually reachable.
   */
  private verifyProductImages(items: ProductModel[]): void {
    // no Image on the server: the check runs again in the browser
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    items
      .filter(
        (item) =>
          item.images?.[0] && item.images[0] !== this.DEFAULT_PRODUCT_IMAGE,
      )
      .forEach((item) => {
        const probe = new Image();
        probe.onerror = () => {
          (item.images as string[])[0] = this.DEFAULT_PRODUCT_IMAGE;
        };
        probe.src = item.images![0] as string;
      });
  }

  /**
   * Product ids of the slider cards whose configuration is in the favorites
   * (cards emit `productId`, favorites are stored by configuration id = `id`)
   */
  get wishlistedProductIds(): number[] {
    const cache = this.wishlistCache;
    if (cache.list !== this.productsList || cache.ids !== this.favoriteConfigurationIds) {
      cache.list = this.productsList;
      cache.ids = this.favoriteConfigurationIds;
      cache.result = this.productsList
        .filter((product) => this.favoriteConfigurationIds.includes(product.id as number))
        .map((product) => product.productId as number);
    }
    return cache.result;
  }

  /** Adds/removes the configuration shown on the clicked card from the favorites */
  handleToggleWishlist(productId: number): void {
    const product = this.productsList.find((item) => item.productId === productId);
    if (product?.id) {
      this.favoriteService.toggle(product.id as number).subscribe();
    }
  }

  handleSelectedProduct(productId: number): void {
    this.productService.productById(productId).subscribe({
      next: (product) => {
        this.product = product;

        // Vérifie que le produit a au moins une configuration
        const configurationId =
          product.configurations && product.configurations.length > 0
            ? product.configurations[0].id
            : 0;

        const safeName = product.name?.replace(/\//g, "-");
        // Redirection dynamique
        this.router.navigate([
          `/products/${safeName}/${productId}/${configurationId}`,
        ]);
      },
      error: (err) => {
        console.error("Erreur lors du chargement du produit :", err);
      },
    });
  }

  oldScrollPosition = 0;

  @HostListener("window:scroll", ["$event"])
  onScrollEvent(event: Event) {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (scrollTop >= 200) {
      this.showFixedHeader = true;
    } else {
      this.showFixedHeader = false;
    }

    if (scrollTop < this.oldScrollPosition) {
      this.showHomeFixedHeaderMenu = true;
    } else {
      this.showHomeFixedHeaderMenu = false;
    }

    this.oldScrollPosition = scrollTop;

    event.stopPropagation();
  }

  /**
   * best Promotion
   */
  /*  getBestPromotion() {
    this.productConfigurationService.getBestPromotion(0, 100).subscribe((response: Response<Page<ProductConfiguration>>) => {
        this.configurations = response.body!.content;
        if (response.body!.totalElements > 0) {
          this.showBestPromotion = true;
        } else {
          this.showBestPromotion = false;
        }
      }
    );

  }*/

  /**
   * flashSale configurations
   */

  getFlashSale() {
    this.productConfigurationService
      .getFlashSale(0, 100)
      .subscribe((response: Response<Page<ProductConfiguration>>) => {
        this.flashSaleConfigurations = response.body!.content;
        if (this.flashSaleConfigurations.length > 0) {
          this.showFlashSale = true;
        } else {
          this.showFlashSale = false;
        }
      });
  }

  getDisplay() {
    this.displayService.getAllDisplayHomeSections().subscribe((res) => {
      for (let display of res.body!) {
        switch (display.name) {
          case "new":
            this.showNew = display.display;
            this.newName = display.displayName;
            break;
          case "trading":
            this.showTrading = display.display;
            this.tradingName = display.displayName;
            break;
          case "bestSales":
            this.showBestSales = display.display;
            this.bestSalesName = display.displayName;
            break;
          case "bestCategory":
            this.showBestCategory = display.display;
            this.bestCategoryName = display.displayName;
            break;
          case "bestPromotion":
            this.showBestPromotions = display.display;
            this.bestPromotionName = display.displayName;
            break;
          case "flashSales":
            this.showFlashSales = display.display;
            this.flashSalesName = display.displayName;
            break;
          case "lastSeen":
            this.showLastSeen = display.display;
            this.lastSeenName = display.displayName;
            break;
        }
      }
    });
  }

  onBrandClicked(id: number) {
    this.router.navigate(["/products/brand", id], {
      queryParams: { inStock: "true" },
    });
  }

  /**
   * @description go to login modal, close passwordChangedPopup and clear localstorage
   */
  goToLoginModal() {
    this.showPasswordChangedPopup = false;
    this.showLoginModal = true;
    this.storage.removeItem("passwordChanged");
  }

  /**
   * @description close the login modal
   */
  closeLoginModal() {
    this.showLoginModal = false;
  }

  /**
   * @description close the passwordChangedPopup and clear localstorage by clicking on the close icon
   */
  closePasswordChangedPopUp() {
    this.showPasswordChangedPopup = false;
    this.storage.removeItem("passwordChanged");
  }

  /**
   * Handles the add-to-cart event emitted by the accueil product slider.
   * Fetches the full configuration then delegates to addConfigurationToCart.
   * @param {{ id: number; productConfigId?: number }} event - Product id and selected configuration id
   */
  onAddToCart(event: { id: number; productConfigId?: number }): void {
    const configurationId = event.productConfigId ?? event.id;
    if (!configurationId) {
      return;
    }

    this.productConfigurationService
      .getByConfigurationId(configurationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (configuration: ProductConfiguration) => {
          this.addConfigurationToCart(configuration);
        },
        error: () => {
          this.updateSnackbar("alert", "homePage.home.genericError");
        },
      });
  }

  /**
   * Adds a product configuration to the cart (online or offline), same logic as
   * ProductListComponent.addConfigurationToCart.
   * @param configuration - The product configuration to add
   */
  private addConfigurationToCart(configuration: ProductConfiguration): void {
    const quantity = 1;

    if (this.accountService.accountSubject.value) {
      // Online storage
      this.cartService.add(configuration, quantity).subscribe({
        next: (response: any) => {
          this.popupConfiguration = configuration;
          this.popupAvailableQuantity = configuration.quantity;
          this.popQuantity = response?.cartProduct?.quantity || quantity;
          this.showAddPopup = true;

          if (response?.quantityCapped) {
            this.updateSnackbar(
              "warning",
              "homePage.home.stockExceeded",
              { quantity: this.popQuantity },
            );
          }
        },
        error: () => {
          this.updateSnackbar("alert", "homePage.home.addToCartError");
        },
      });
    } else {
      // Offline storage
      const cartProduct: CartProduct = {
        configuration,
        quantity,
        configurationId: configuration.id,
      };

      this.cartOffLineService.addCarts(cartProduct).subscribe({
        next: (response) => {
          if (response.success) {
            this.cartOffLineService.cart
              .pipe(take(1))
              .subscribe((res: cartLocal) => {
                const existingProduct = res?.CartProduct?.find(
                  (c: any) => c.configuration.id === cartProduct.configurationId,
                );
                this.popupConfiguration = configuration;
                this.popupAvailableQuantity = configuration.quantity;
                this.popQuantity = existingProduct?.quantity ?? quantity;
                this.showAddPopup = true;
              });
          }
          if (response.quantityCapped) {
            this.updateSnackbar(
              "warning",
              "homePage.home.stockExceededNoQuantity",
            );
          }
        },
        error: () => {
          this.updateSnackbar("alert", "homePage.home.addToCartError");
        },
      });
    }
  }

  /**
   * Shows a temporary snackbar message.
   * @param theme - Snackbar theme
   * @param key - Translation key of the snackbar message
   * @param params - Values of the message placeholders
   */
  private updateSnackbar(
    theme: "warning" | "alert" | "success" | "information",
    key: string,
    params?: Record<string, unknown>,
  ): void {
    this.snackbarTheme = theme;
    this.snackbarText = this.translate.instant(key, params);
    this.showSnackbar = true;

    setTimeout(() => {
      this.showSnackbar = false;
    }, 3000);
  }

  /**
   * Updates the "added to cart" popup visibility state.
   * @param showPopup - Boolean to show or hide the popup
   */
  onShowAddPopupChange(showPopup: boolean): void {
    this.showAddPopup = showPopup;
  }

  /**
   * Navigates to the cart page.
   */
  onSeeCart(): void {
    this.router.navigate(["/cart"]);
  }

  /**
   * Closes the "added to cart" popup so the user can keep browsing.
   */
  onContinueShopping(): void {
    this.showAddPopup = false;
  }

  ngOnDestroy() {
    this.storage.removeItem("passwordChanged");
    this.destroy$.next();
    this.destroy$.complete();
  }
}
